"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ImagesList;

var _react = _interopRequireDefault(require("react"));

var _Picture = _interopRequireDefault(require("Picture"));

var _scss = require("@scss");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["image", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ImagesList(_ref) {
  var images = _ref.images,
      classes = _ref.classes,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['images-container'], classes === null || classes === void 0 ? void 0 : classes.wrapper, className)
  }, images && images.map(function (_ref2, i) {
    var image = _ref2.image,
        classes = _ref2.classes,
        props = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/_react["default"].createElement(_Picture["default"], _extends({
      key: "item-card-list-".concat(i),
      image: image,
      classes: _objectSpread(_objectSpread({}, classes), {}, {
        wrapper: classes === null || classes === void 0 ? void 0 : classes.image
      })
    }, props));
  }));
}